<script setup lang="ts">
import Loading from "@/components/shared/Loading.vue";
defineOptions({ inheritAttrs: false });
const type = ["card-avatar", "article", "actions"];
</script>

<template>
  <div>
    <slot />
    <Loading :typeLoading="type">
      <slot name="loading" />
    </Loading>
  </div>
</template>
